"use client";

import { GameExperience } from "@/components/feature/game-experience";
import type { PageOriginContext } from "@/lib/page-origin-context";

interface GamePageProps {
  slug: string;
  pageOrigin?: PageOriginContext | null;
  /** Fixed close/back destination (e.g. "/testgames"). Overrides origin resolution. */
  returnHref?: string;
}

/** Direct-visit game page shell (full viewport, no site chrome). */
export function GamePage({ slug, pageOrigin, returnHref }: GamePageProps) {
  return (
    <div className="relative flex h-[100dvh] min-h-0 max-h-[100dvh] flex-col overflow-hidden bg-ink text-white">
      <GameExperience slug={slug} mode="page" pageOrigin={pageOrigin} returnHref={returnHref} />
    </div>
  );
}
